import { render, staticRenderFns } from "./experts.vue?vue&type=template&id=b5655986"
import script from "./experts.vue?vue&type=script&lang=js"
export * from "./experts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports